import React, { lazy, Suspense, useState } from "react";
// material
import { styled } from "@mui/material/styles";
import CircularLoader from "../../components/circularLoader";
//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import useMediaQuery from "@mui/material/useMediaQuery";
import routes from "../../routes";
import { Route, Switch } from "react-router-dom";
import ScrollTop from "../../components/ScrollTop";
import { Box, Fab } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import "./DashboardLayout.css"
import { StorageUtils } from "../../utils";
import { APP_USER_SESSION } from "../../constant/AppConstants";
import { hasScope } from "../../utils/openidUtils";
import { prefixV3 } from "../../utils/constants";
import { styles } from "../../utils/styles";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  overflow: "hidden",

  [theme.breakpoints.up("lg")]: {
    "&:has(.collapse-menu) > .docs-content-wrapper": {
      paddingLeft: 65
    }
  }
}));

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 300,
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

const loadComponent = (entry) => {
  const Component = entry.lazyLoad ? lazy(entry.lazyLoad) : entry.component;
  return props => <Component {...props} />
}

const renderComponent = (p, userRole) => {
  return (
    <Route
      exact
      key={p.name}
      path={prefixV3 + p.path}
      render={(props) => loadComponent(p)({ ...props, userRole: userRole[p.scope] })}
    />
  );
}

const DashboardLayout = (props) => {
  const [open, setOpen] = useState(false);
  const hidden = useMediaQuery((theme) => theme.breakpoints.up("lg"), { noSsr: true});

  const getRoutes = (routes) => {
    const userRole = StorageUtils.getParsedValue(APP_USER_SESSION).role;

    return routes.map(p => {
      if (!hasScope(p.scope, userRole, p.role)) return 
      return renderComponent(p, userRole)
    })
  };

  return (
    <>
      <RootStyle className="docs-app" id="back-to-top-anchor">
        <DashboardSidebar
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
          hidden={hidden}
        />

        <MainStyle className="docs-content-wrapper">
          <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
          <Box sx={{ mx: 2 }}>
            <Suspense fallback={
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '100vh' 
              }}>
                <CircularLoader size={40} />
              </Box>
            }>
              <Switch>{getRoutes(routes)}</Switch>
            </Suspense>
          </Box>
          <ScrollTop {...props}>
            <Fab
              sx={[
                { ...styles.customButton, color: "#fff" },
              ]}
              size="large"
              aria-label="Scroll Back to Top"
            >
              <ArrowUpwardIcon />
            </Fab>
          </ScrollTop>
        </MainStyle>
      </RootStyle>
    </>
  );
};

export default DashboardLayout;
